module.exports = "<p>\n  merge-vendors-confirmation works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/views/merge-vendors/merge-vendors-confirmation/merge-vendors-confirmation.component.html
// module id = ../../../../../angular/app/views/merge-vendors/merge-vendors-confirmation/merge-vendors-confirmation.component.html
// module chunks = main